import { z } from "zod";

/**
 * Validación del formulario del lead magnet (RF-5, RF-7).
 *
 * Espeja la regla del backend: si acá pasa, el servidor también lo acepta
 * (mismo formato de email, normalizado a minúsculas).
 */
export const leadFormSchema = z.object({
  email: z.string().trim().toLowerCase().email("Ingresá un email válido"),

  /** Honeypot: invisible para las personas, los bots lo completan. */
  website: z.string().optional(),
});

export type LeadFormValues = z.infer<typeof leadFormSchema>;
